import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSortModule } from '@angular/material/sort';
import { RouterModule } from '@angular/router';
import { NgApexchartsModule } from 'ng-apexcharts';
import { ActionButtonComponent } from './components/action-button/action-button.component';
import { ActionMenuComponent } from './components/action-menu/action-menu.component';
import { ActionModalComponent } from './components/action-modal/action-modal.component';
import { AlertComponent } from './components/alert/alert.component';
import { CardWithBooleanComponent } from './components/card-with-boolean/card-with-boolean.component';
import { ChartComponent } from './components/chart/chart.component';
import { CustomLineChartComponent } from './components/custom-line-chart/custom-line-chart.component';
import { GenerateAiSummaryComponent } from './components/generate-ai-summary/generate-ai-summary.component';
import { ListAndFormComponent } from './components/list-and-form/list-and-form.component';
import { ListComponent } from './components/list/list.component';
import { NoHighlightAutocompleteComponent } from './components/no-highlight-autocomplete/no-highlight-autocomplete.component';
import { PaServiceCalculatorComponent } from './components/pa-service-calculator/pa-service-calculator.component';
import { ParentChartComponent } from './components/parent-chart/parent-chart.component';
import { SaturdayChartComponent } from './components/saturday-chart/saturday-chart.component';
import { PdfButtonComponent } from './components/pdf-button/pdf-button.component';
import { ListColumnsPipe } from './components/pipes/list-columns.pipe';
import { SkeletonLoaderComponent } from './components/skeleton-loader/skeleton-loader.component';
import { SplitTableComponent } from './components/split-table/split-table.component';
import { TableModule } from './components/table/table.module';
import { UnitsDisplayComponent } from './components/units-display/units-display.component';
import { DataService } from './data/data.service';
import { DebounceInputDirective } from './directives/debounce-input.directive';
import { EditWrapperDirective } from './directives/edit-wrapper.directive';
import { FeatureFlagDirective } from './directives/feature-flag.directive';
import { FeatureFlagDisabledDirective } from './directives/feature-flag-disabled.directive';
import { InputDirective } from './directives/input.directive';
import { PhoneInputMaskDirective } from './directives/phone-input-mask.directive';
import { MaterialModule } from './extras/material.module';
import { NgxBootstrapModule } from './ngx-bootstrap/ngx-bootstrap.module';
import { NoInfoComponent } from './no-info/no-info.component';
import { PipesModule } from './pipes/pipes.module';
import { PageService } from './services/pages.service';
import { GoodDayComponent } from './components/good-day/good-day.component';
import { PdfSectionSelectorComponent } from './components/pdf-section/pdf-section-selector/pdf-section-selector.component';
import { PdfSectionModalErrorComponent } from './components/pdf-section/pdf-section-error/pdf-section-modal-error.component';
import { SectionSelectorModalComponent } from './components/section-selector-modal/section-selector-modal/section-selector-modal.component';
import { VersionMismatchAlertComponent } from './components/version-mismatch-alert/version-mismatch-alert.component';
import { CustomerServiceIconComponent } from './components/customer-service-icon/customer-service-icon.component';
import { ProductionWarningBannerComponent } from './components/production-warning-banner/production-warning-banner.component';
import { SiteAlertBannerComponent } from './components/site-alert-banner/site-alert-banner.component';
import { LazySelectModule } from './components/lazy-select/lazy-select.module';
import { LazySearchSelectModule } from './components/lazy-search-select/lazy-search-select.module';
import { DatatableExpandableComponent } from './components/datatable-expandable/datatable-expandable.component';
import { DatatableComponent } from './components/datatable/datatable.component';
import { ArrowRightIconComponent } from './icons/arrow-right-icon/arrow-right-icon.component';
import { ChipsComponent } from './components/chips/chips.component';
import { EditableRecordsTableComponent } from './components/editable-records-table/editable-records-table.component';
import { InlineEditorModule } from 'src/app/shared/components/inline-editor/inline-editor.module';
import { MatExpansionModule } from '@angular/material/expansion';
import {MatCheckboxModule} from "@angular/material/checkbox";
import { ImpersonationComponentsModule } from './components/impersonation-components.module';
import { TimeInputV2Component } from './components/time-input-v2/time-input-v2.component';
import { TimeInputV3Component } from './components/time-input-v3/time-input-v3.component';
// import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';
import { MatTimepickerModule } from '@dhutaryan/ngx-mat-timepicker';
import { TimeInputV4Component } from './components/time-input-v4/time-input-v4.component';
import { AppDatepickerModule } from './components/app-datepicker/app-datepicker.module';


const components = [
  NoInfoComponent,
  SkeletonLoaderComponent,
  ActionButtonComponent,
  ActionMenuComponent,
  ActionModalComponent,
  ArrowRightIconComponent,
  UnitsDisplayComponent,
  PaServiceCalculatorComponent,
  AlertComponent,
  ListComponent,
  ListAndFormComponent,
  ListColumnsPipe,
  PdfButtonComponent,
  InputDirective,
  GenerateAiSummaryComponent,
  EditWrapperDirective,
  DebounceInputDirective,
  FeatureFlagDirective,
  FeatureFlagDisabledDirective,
  PhoneInputMaskDirective,
  SplitTableComponent,
  CardWithBooleanComponent,
  ChartComponent,
  ChipsComponent,
  CustomLineChartComponent,
  ParentChartComponent,
  SaturdayChartComponent,
  NoHighlightAutocompleteComponent,
  GoodDayComponent,
  PdfSectionSelectorComponent,
  PdfSectionModalErrorComponent,
  SectionSelectorModalComponent,
  VersionMismatchAlertComponent,
  CustomerServiceIconComponent,
  ProductionWarningBannerComponent,
  SiteAlertBannerComponent,
  DatatableExpandableComponent,
  DatatableComponent,
  EditableRecordsTableComponent,
];

const standaloneComponents = [
  TimeInputV2Component,
  TimeInputV3Component,
  TimeInputV4Component
];

@NgModule({
  declarations: [...components],
  imports: [
    CommonModule,
    NgxBootstrapModule,
    NgApexchartsModule,
    MaterialModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    PipesModule,
    InlineEditorModule,
    ...standaloneComponents,
    MatExpansionModule,
    MatCheckboxModule,
    ImpersonationComponentsModule,
    // NgxMatTimepickerModule,
    MatTimepickerModule,
    AppDatepickerModule,
  ],
  exports: [
    ...components,
    ...standaloneComponents,
    CommonModule,
    NgxBootstrapModule,
    NgApexchartsModule,
    HttpClientModule,
    MaterialModule,
    MatSortModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    PipesModule,
    InlineEditorModule,
    TableModule,
    PdfSectionSelectorComponent,
    SectionSelectorModalComponent,
    LazySelectModule,
    MatExpansionModule,
    MatCheckboxModule,
    LazySearchSelectModule,
    ImpersonationComponentsModule,
    // NgxMatTimepickerModule,
    MatTimepickerModule,
    AppDatepickerModule,
  ],
  providers: [DataService, PageService],
})
export class SharedModule {}
